import gql from 'graphql-tag';

const GET_UPLOAD_URL = gql`
  query getUploadSignedUrl($filename: String!) {
    getUploadSignedUrl(filename: $filename) {
      url
      filename
    }
  }
`;

export default {
  GET_UPLOAD_URL,
};
